import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useOnlineStatus } from 'hooks/useOnlineStatus';
import { useInventorizeStepsStore } from 'routes/inventorize_meter/components/store';
import { useInstallMeterStepsStore } from 'routes/installation/components/store';
import { useSessionStore } from 'store/session';
import { useStore as useInventorizeMeterStore } from 'routes/inventorize_meter/useStore';
import { useStore as useInstallationMeterStore } from 'routes/installation/useStore';
import { useStore as useMeterListStore } from 'routes/meter_list/useStore';
import { useReplaceMeterStore } from 'routes/meter_replacement/useStore';
import { useReplaceMeterStepsStore } from 'routes/meter_replacement/useStepsStore';
import { HomeButton } from '../button/Home';
import { StyledHeaderLeftWrapper } from './styled/LeftWrapper';

export const HeaderLeftSide: FC = () => {
  const navigate = useNavigate();
  const { apiKey } = useSessionStore();
  const { pathname } = useLocation();
  const { isOnline } = useOnlineStatus();

  const { reset: resetInstallMeterStepsStore } = useInstallMeterStepsStore();
  const { reset: resetInventorizeStepsStore } = useInventorizeStepsStore();
  const { reset: resetReplaceMeterStepsStore } = useReplaceMeterStepsStore();

  const { reset: resetInventorizeMeterStore } = useInventorizeMeterStore();
  const { reset: resetInstallationMeterStore } = useInstallationMeterStore();
  const { reset: resetMeterListStore } = useMeterListStore();
  const { reset: resetReplaceMeterStore } = useReplaceMeterStore();

  const handleHomeButton = () => {
    // reset steps
    resetInstallMeterStepsStore();
    resetInventorizeStepsStore();
    resetReplaceMeterStepsStore();

    // reset stores
    resetInventorizeMeterStore();
    resetInstallationMeterStore();
    resetMeterListStore();
    resetReplaceMeterStore();

    navigate('/');
  };

  return (
    <StyledHeaderLeftWrapper>
      {apiKey !== null && pathname !== '/' && <HomeButton onClick={handleHomeButton} />}
      {isOnline ? '' : 'OFFLINE'}
    </StyledHeaderLeftWrapper>
  );
};
